import CloseIcon from "Assets/Icons/CloseIcon";
import { ToastContextDispatch } from "Context/CommonContext";
import TOCModal from "Pages/MySchedule/TOCModal/TOCModal";
import moment from "moment";
import { useContext, useEffect, useState } from "react";
import { Modal } from "reactstrap";
import styled from "styled-components";
import { getAPIRequest } from "utilFunctions/Axios/AxiosRequestConfiguration";
import getRequestInterface from "utilFunctions/Axios/getRequestInterface";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import DraggableModal from "utilFunctions/shared/DraggableModal";
interface LectureShowModalComponentIF {
  selectedLectureDetail: any;
  selectedlecture: any;
  ispaneopen: any;
  toggleModal: any;
  screen: any;
  setIspaneOpen: any;
  userInfo: any;
  batchDetailsData?: any;
}
const StyledLectureHeaderMain = styled<any>("div")`
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: ${({ screen }: any) =>
    ["xs", "sm", "md"].includes(screen) ? "0px" : "12px"};
  border-bottom: ${({ screen }: any) =>
    ["xs", "sm", "md"].includes(screen) ? "0px" : "0.5px solid #eee"};
`;
const StyledLectureHeader = styled<any>("div")`
  font-weight: 600;
  color: #333;
  font-size: ${({ screen }: any) =>
    ["xs", "sm", "md"].includes(screen) ? "14px" : "20px"};
`;
const LectureShowModalComponent: any = ({
  selectedLectureDetail,
  selectedlecture,
  ispaneopen,
  toggleModal,
  setIspaneOpen,
  userInfo,
  batchDetailsData,
}: LectureShowModalComponentIF) => {
  const { screen }: any = useWindowSize();
  const ToastDispatch = useContext<any>(ToastContextDispatch);
  const [planneLecturedList, setplanneLecturedList] = useState<any>([]);
  const [plannedLecture, setplannedLecture] = useState<any>(null);
  const [allCoveredTopics] = useState<any>([]);
  useEffect(() => {
    if (selectedLectureDetail && selectedLectureDetail.fexRecordId) {
      setplanneLecturedList([
        {
          isComplete: 3,
          id: selectedLectureDetail.fexRecordId,
        },
      ]);
    }
  }, [selectedLectureDetail]);
  const getPlannedLecture = async (url: string) => {
    await getAPIRequest({
      url: url,
      success: (response: any) => {
        if (response && response["data"] && response["data"]["data"]) {
          setplanneLecturedList(
            response["data"]["data"]["plannedLectureIdList"]
          );
          setplannedLecture(response["data"]["data"]);
        } else {
          setplanneLecturedList([]);
          setplannedLecture([]);
        }
      },
      failure: (error: any) => {
        setplanneLecturedList([]);
        setplannedLecture([]);
        ToastDispatch({
          isOpen: true,
          type: "Error",
          message:
            error?.response?.data?.code == "NF"
              ? "No Topic Present for this lecture"
              : error.message,
        });
      },
    } as getRequestInterface);
  };
  const modalCloseHandler = () => {
    toggleModal();
  };
  const ScheduledHeader = () => {
    return (
      <StyledLectureHeaderMain screen={screen}>
        {["xs", "sm", "md"].includes(screen) ? (
          <StyledLectureHeader screen={screen}>
            {selectedLectureDetail != null &&
              " " + selectedLectureDetail?.eventName}{" "}
            |{" "}
            {selectedLectureDetail &&
              moment(selectedLectureDetail?.startTime).format("D MMM YYYY")}
          </StyledLectureHeader>
        ) : (
          <StyledLectureHeader screen={screen}>
            Topics marked in
            {selectedLectureDetail != null &&
              " " + selectedLectureDetail?.eventName}{" "}
            |{" "}
            {selectedLectureDetail &&
              moment(selectedLectureDetail?.startTime).format("D MMM YYYY")}
          </StyledLectureHeader>
        )}
        <CloseIcon
          className="cursorHoverCSS"
          onClick={() => {
            toggleModal();
            ClearAllFileds();
          }}
        ></CloseIcon>
      </StyledLectureHeaderMain>
    );
  };
  const ClearAllFileds = () => {
    setplanneLecturedList([]);
    setplannedLecture([]);
  };
  console.log(
    "batchDetailsData",
    selectedLectureDetail,
    "====",
    selectedlecture,
    batchDetailsData
  );
  return (
    <>
      {" "}
      {["xs", "sm", "md"].includes(screen) ? (
        <DraggableModal isPaneOpen={ispaneopen} togglePane={toggleModal}>
          <div>
            <div className="commentDropdownDiv">
              <ScheduledHeader />
            </div>
            <div id="commentFooter" className="pt-5 p-3">
              <TOCModal
                mode="lectureDetailTab"
                selectedlecture={selectedlecture}
                planneLecturedList={planneLecturedList}
                allCoveredTopics={allCoveredTopics}
                plannedLecture={plannedLecture}
                toggleModal={toggleModal}
                userInfo={userInfo}
                getPlannedLecture={getPlannedLecture}
                screen={screen}
                modalCloseHandler={modalCloseHandler}
                header={null}
                ispaneopen={ispaneopen}
                batchName={batchDetailsData?.batchName}
                subject={selectedlecture.subject}
              ></TOCModal>
            </div>
          </div>
        </DraggableModal>
      ) : (
        <Modal
          isOpen={ispaneopen}
          centered={true}
          backdrop={true}
          size={"lg"}
          fullscreen={true}
          toggle={() => {
            setIspaneOpen(!ispaneopen);
          }}
          className={
            ["xs", "sm", "md"].includes(screen)
              ? "syllabusModal"
              : "syllabusModalDK"
          }
        >
          <div className={"lectureScheduledBody"}>
            <ScheduledHeader />
            <TOCModal
              mode="lectureDetailTab"
              selectedlecture={selectedlecture}
              planneLecturedList={planneLecturedList}
              allCoveredTopics={allCoveredTopics}
              plannedLecture={plannedLecture}
              toggleModal={toggleModal}
              userInfo={userInfo}
              getPlannedLecture={getPlannedLecture}
              screen={screen}
              modalCloseHandler={modalCloseHandler}
              header={null}
              ispaneopen={ispaneopen}
            ></TOCModal>
          </div>
        </Modal>
      )}
    </>
  );
};
export default LectureShowModalComponent;
